import React from "react";
import {
  Card,
  SkeletonButton,
  SkeletonHeading,
  SkeletonText,
} from "@ovotech/element";

export const LoadingSkeleton = (props: { card: boolean }) => {
  const content = (
    <>
      <SkeletonHeading />
      <SkeletonText lines={6} />
      <SkeletonButton />
    </>
  );

  return props.card ? <Card>{content}</Card> : content;
};

LoadingSkeleton.defaultProps = {
  card: false,
};
